<div class="card height-100 custom-color p-shadow-9">
    <h5 class="centerText">Број посета наспрам броја скидања апликације</h5>
    <p-chart [data]="lineChartData" [options]="lineChartOptions" type="line" height="500px"></p-chart>
</div>
